<template>
  <div
    v-if="metadata.settingsVars.NEW_QUICK_EMAIL_SIGNUP"
    :class="modalClasses + ' qes-modal-new'"
    style="background: none; box-shadow: none"
  >
    <WineTrailThankYou :active="thankYou" v-bind="$attrs" />
    <WineTrailEmailSignup :active="!thankYou && !qes" v-bind="$attrs" />
  </div>
  <div v-else :class="modalClasses + ' qes-modal-old'" @click.stop>
    <ThankYou v-if="thankYou" v-bind="$attrs" />
    <QuickEmailSignup v-if="!thankYou && !qes" v-bind="$attrs" />
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  components: {
    WineTrailEmailSignup: defineAsyncComponent(
      () => import('@/components/Index/WineTrailEmailSignup'),
    ),
    QuickEmailSignup: defineAsyncComponent(
      () => import('@/components/Index/QuickEmailSignup'),
    ),
    ThankYou: defineAsyncComponent(() => import('@/components/Index/ThankYou')),
    WineTrailThankYou: defineAsyncComponent(
      () => import('@/components/Index/WineTrailThankYou'),
    ),
  },
  props: {
    open: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['closed'],
  data() {
    return {
      modalClasses: 'qes-modal-dialog modal-container home-email-modal',
    }
  },
  computed: {
    ...mapGetters(['thankYou', 'qes']),
  },
  created() {
    this.metadata = useMetadata()
  },
  mounted() {
    document.body.addEventListener('click', () => this.$emit('closed'))
  },
  unmounted() {
    document.body.removeEventListener('click', () => this.$emit('closed'))
  },
}
</script>

<style lang="scss">
@import '../../assets/scss/components/quickEmailSignUpModal/quick-email-signup-modal.scss';
</style>
